import { getStripeSetupIntentClientSecret } from "@api/getStripeSetupIntentClientSecret";
import { useQuery } from "@tanstack/react-query";

export const useGetStripeSetupIntentClientSecret = (uuid: string) =>
  useQuery<{ data: string; error?: string }, Error>({
    queryKey: ["stripe-setup-intent", uuid],
    queryFn: () => getStripeSetupIntentClientSecret({ uuid }),
    enabled: false,
  });
